import { AccordionContainer, Accordion, BreadcrumbTemplateEnum, Breadcrumbs, Page, PageHeader, PageInner, PageSection } from "@app/shared";
import { EditTutorialsList } from "./EditTutorialsList"
import { QesIcons } from "@app/shared/icons/qesIcons";
import { JSX } from "react";

const EditTutorials = (): JSX.Element => {
  return (
    <>
      {(
        <Page documentTitle="Manage Tutorials - Admin">
          <Breadcrumbs
            template={BreadcrumbTemplateEnum.Admin}
            items={[
              {
                iconClass: "fa-pencil",
                text: "Manage Tutorials",
              },
            ]}
          />
          <PageInner>
            <PageHeader title="Manage Quest Analytics Tutorials" iconName={QesIcons.FontAwesome.Pencil}></PageHeader>

            <PageSection>
              <div className="col-12 col-sm-8 mt-3">
                {renderHeaderRow("Updates")}
                <div className="card-striped">
                  <AccordionContainer>
                    <Accordion title="New Features" testId="edit-tutorials__new-features-accordion">
                      <EditTutorialsList containerName="new-features" friendlyName="New Features" />
                    </Accordion>
                    <Accordion title="Webinars" testId="edit-tutorials__webinars-accordion">
                      <EditTutorialsList containerName="webinars" friendlyName="Webinars" enableHyperlink={true} />
                    </Accordion>
                    <Accordion title="QES What's New Webinars" testId="edit-tutorials__whats-new-webinar-accordion">
                      <EditTutorialsList containerName="whats-new-webinars" friendlyName="QES What's New Webinars" enableHyperlink={true} />
                    </Accordion>
                    <Accordion title="QES Web Learning Series" testId="edit-tutorials__web-learning-series-accordion">
                      <EditTutorialsList containerName="web-learning-series" friendlyName="QES Web Learning Series" enableHyperlink={true} />
                    </Accordion>
                  </AccordionContainer>
                </div>
              </div>
            </PageSection>

            <PageSection>
              <div className="col-12 col-sm-8">
                {renderHeaderRow("Guides")}
                {subHeadingRow("Quest Analytics Suite")}
                <EditTutorialsList containerName="qas-user-guides" friendlyName="Quest Analytics Suite Guides" />
                <br />
                {subHeadingRow("Quest Enterprise Services")}
                <EditTutorialsList containerName="qes-user-guides" friendlyName="Quest Enterprise Services Guide" editOnly={true} />
              </div>
            </PageSection>
          </PageInner>
        </Page>
      )}
    </>
  );
}

const subHeadingRow = (title: string) => (
  <div className="row">
    <div className="col-12">
      <p className="h6 mb0">{title}</p>
    </div>
  </div>
);

function renderHeaderRow(rowTitle: string) {
  return (
    <div className="row">
      <div className="col-12">
        <p className="lead mb0">{rowTitle} </p>
        <hr className="mt0" />
      </div >
    </div >
  );
}

export { EditTutorials };
